import React, { Fragment } from 'react';

const FundsNotFound = ({ fundsNotFound, classes }: any) => {
  return (
    <Fragment>
      {fundsNotFound.length !== 0 && (
        <div className={classes.title}>Funds not found</div>
      )}
      {fundsNotFound.map((notFound: any, i: number) => {
        return (
          <div
            key={`nf${i}`}
            className={classes.foundRow}
            style={{
              backgroundColor: i % 2 === 0 ? '#f9f9f9' : 'white'
            }}
          >
            <div className={classes.code}>{notFound.code}</div>
            <div className={classes.result}>{notFound.result}</div>
          </div>
        );
      })}
    </Fragment>
  );
};

export default FundsNotFound;
